<style scoped></style>

<template>
  <Form label-position="top" ref="form" :model="formData" :rules="rules">
    <FormItem label="名称" prop="name">
      <Input v-model="formData.name" placeholder="请输入名称" />
    </FormItem>
    <FormItem label="类型" prop="type">
      <RadioGroup v-model="formData.type">
        <Radio border :label="item.value" :key="item.value" v-for="item in scmGoodsHandleTypeList">{{ item.label }}</Radio>
      </RadioGroup>
    </FormItem>
    <FormItem label="计划完成时间" prop="planEndTime">
      <DatePicker type="datetime" :value="formData.planEndTime" @on-change="time => formData.planEndTime = time" placeholder="请选择开始时间"></DatePicker>
    </FormItem>
    <FormItem label="备注" prop="remark">
      <Input type="textarea" v-model="formData.remark" placeholder="请输入备注" />
    </FormItem>
  </Form>
</template>

<script>
export function getDefault () {
  return {
    id: null,
    name: null,
    type: 1,
    planEndTime: null,
    remark: null
  }
}

const rules = Object.freeze({
  name: [
    { required: true, message: '请输入名称' }
  ],
  type: [
    { required: true, message: '请选择类型' }
  ]
})

export default {
  props: {
    data: { type: Object, default: null }
  },
  data () {
    return {
      formData: this.data ? JSON.parse(JSON.stringify(this.data)) : getDefault(),
      rules
    }
  },
  computed: {
    scmGoodsHandleTypeList () {
      return this.$store.getters.scmGoodsHandleTypeList
    }
  },
  watch: {
    data: {
      deep: true,
      handler () {
        this.formData = this.data ? JSON.parse(JSON.stringify(this.data)) : getDefault()
      }
    }
  },
  methods: {
    getFormData () {
      return new Promise(resolve => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            resolve(JSON.parse(JSON.stringify(this.formData)))
          } else {
            resolve(false)
          }
        })
      })
    }
  }
}
</script>
